import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";

import {
  RegisterReducer,
  verifyTimeReducer,
  resendEmailReducer,
  verifyEmailReducer,
  updateUserReducer,
  forgotPasswordReducer,
  allUsersReducer,
  updateRoleReducer,
  updateAvatarReducer
} from "./redux/reducers/userReducers";

import {
  exportUpcExcelReducer,
  mappingReducer,
  myMappingsReducer,
  myUpcSlipsReducer,
  upcScanReducer
} from "./redux/reducers/upcScanReducer";

import { allProductsReducer, productReducer, updateProductReducer } from "./redux/reducers/productReducers";

const reducer = combineReducers({
  register: RegisterReducer,
  verifyTime: verifyTimeReducer,
  resendEmail: resendEmailReducer,
  verifyEmailStore: verifyEmailReducer,
  updateUser: updateUserReducer,
  forgotPassword: forgotPasswordReducer,
  allUsers: allUsersReducer,
  updateRole: updateRoleReducer,
  updateavtar: updateAvatarReducer,

  upcScan: upcScanReducer,
  myUpcSlips: myUpcSlipsReducer,
  exportUpcExcel: exportUpcExcelReducer,
  product: productReducer,
  products: allProductsReducer,

  productMessage: updateProductReducer,


  myMappings: myMappingsReducer,
  mapping: mappingReducer,
});

const initialState = {};
const middleware = [thunk];

// ✅ Enable Redux DevTools only in development
const composeEnhancers =
  process.env.NODE_ENV === "development" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const store = createStore(
  reducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
